import React, { useEffect, useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import MainContentHeader from './layouts/content/MainContentHeader';
import MainContentCard from './layouts/content/MainContentCard';
import AppContext, { ProductContext } from 'context/Context';
import { initWinXinInPage } from 'y4/WeiXin';
import { login } from 'y4/Falcon';
import { useTranslation } from 'react-i18next';
import DataContext from 'y4/context/DataContext';
import { encrypt } from './Utils';
import { isAuthorized } from './Authentication';

const ProductWeiXinElement = () => {
  const { t } = useTranslation('auth');
  const { setGlobalData } = useContext(DataContext);
  const {
    config: { team, corp }
  } = useContext(AppContext);

  const {
    productsState: { config }
  } = useContext(ProductContext);

  const [form, setForm] = useState();

  useEffect(() => {
    initWinXinInPage(
      config,
      wx_user => {
        if (!isAuthorized(corp)) {
          login(
            team,
            corp,
            'wxopenid',
            wx_user.openId,
            encrypt(JSON.stringify(wx_user)),
            false,
            null,
            setGlobalData,
            t
          );
        }
        setForm(null);
      },
      () => {
        setForm(null);
      },
      e => {
        setForm(e);
      }
    );
  }, []);

  return (
    <>
      <MainContentHeader form={form} />
      {form && form.title ? (
        <MainContentCard title={form.title}>{form.description}</MainContentCard>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default ProductWeiXinElement;
